import { useMemo } from "react";
import { supabase } from "@/integrations/supabase/client";

const BUCKET = "place-images";
const cache = new Map<string, string>();

export function getPlaceCoverUrlCached(coverImagePath: string | null | undefined): string | null {
  if (!coverImagePath) return null;

  // Full URL already
  if (coverImagePath.startsWith("http://") || coverImagePath.startsWith("https://")) {
    return coverImagePath;
  }

  // Check cache
  const cached = cache.get(coverImagePath);
  if (cached) return cached;

  try {
    const { data } = supabase.storage.from(BUCKET).getPublicUrl(coverImagePath);
    if (data?.publicUrl) {
      cache.set(coverImagePath, data.publicUrl);
      return data.publicUrl;
    }
  } catch {
    // Silently fail
  }
  return null;
}

/**
 * React hook for a single cover URL with memoization
 */
export function usePlaceCoverUrl(coverImagePath: string | null | undefined): string | null {
  return useMemo(() => getPlaceCoverUrlCached(coverImagePath), [coverImagePath]);
}
